import { useQuery } from '@tanstack/react-query';
import type { ColumnDef } from '@tanstack/react-table';
import { useEffect } from 'react';
import DataTable from '../components/DataTable';
import { apiFetch } from '../lib/api';
import { toast } from 'sonner';

type Row = Record<string, string | number | boolean>;

export default function UnsubscribesPage() {
  const { data = [], isLoading, error } = useQuery({
    queryKey: ['unsubscribes'],
    queryFn: async () => {
      const res = await apiFetch('/marketing/unsubscribe');
      if (!res.ok) throw new Error(String(res.status));
      return res.json() as Promise<Row[]>;
    },
  });

  useEffect(() => {
    if (error) toast.error('Could not load unsubscribes.');
  }, [error]);

  const keys = data[0] ? Object.keys(data[0]) : [];
  const columns: ColumnDef<Row, string>[] = keys.map((k) => ({
    accessorKey: k,
    header: k,
  }));

  if (isLoading) return <p className="text-ink-muted">Loading…</p>;

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-ink">Marketing unsubscribes</h1>
      <DataTable data={data} columns={columns} />
    </div>
  );
}
